
import { StrucnoUsavrsavanje } from './strucno-usavrsavanje';
import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { ControlContainer, NgForm, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-strucno-usavrsavanje-update',
  templateUrl: './strucno-usavrsavanje-update.component.html'
})
export class StrucnoUsavrsavanjeUpdateComponent extends BaseUpdateComponent<StrucnoUsavrsavanje> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("OsobaId", Validators.required, 'required', 'STRUCNOUSAVRSAVANJE.OSOBA.VALIDATION.REQUIRED');
    this.addValidatorToFc("TipPotvrdeOStrucnomUsavrsavanjuId", Validators.required, 'required', 'STRUCNOUSAVRSAVANJE.TIPPOTVRDEOSTRUCNOMUSAVRSAVANJU.VALIDATION.REQUIRED');
    this.addValidatorToFc("TipStrucnogUsavrsavanjaId", Validators.required, 'required', 'STRUCNOUSAVRSAVANJE.TIPSTRUCNOGUSAVRSAVANJA.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'STRUCNOUSAVRSAVANJE.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(50), 'maxlength', 'STRUCNOUSAVRSAVANJE.NAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Predavac", Validators.required, 'required', 'STRUCNOUSAVRSAVANJE.PREDAVAC.VALIDATION.REQUIRED');
    this.addValidatorToFc("Predavac", Validators.maxLength(75), 'maxlength', 'STRUCNOUSAVRSAVANJE.PREDAVAC.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Trajanje", Validators.required, 'required', 'STRUCNOUSAVRSAVANJE.TRAJANJE.VALIDATION.REQUIRED');
    this.addValidatorToFc("Datum", Validators.required, 'required', 'STRUCNOUSAVRSAVANJE.DATUM.VALIDATION.REQUIRED');   
    this.addValidatorToFc("RealizovanOdDatuma", Validators.required, 'required', 'STRUCNOUSAVRSAVANJE.REALIZOVANOODDATUMA.VALIDATION.REQUIRED');
    this.addValidatorToFc("RealizovanDoDatuma", Validators.required, 'required', 'STRUCNOUSAVRSAVANJE.REALIZOVANODODATUMA.VALIDATION.REQUIRED');
    this.addValidatorToFc("BrojBodova", Validators.required, 'required', 'STRUCNOUSAVRSAVANJE.BROJBODOVA.VALIDATION.REQUIRED');
    this.addValidatorToFc("Institucija", Validators.required, 'required', 'STRUCNOUSAVRSAVANJE.INSTITUCIJA.VALIDATION.REQUIRED');
    this.addValidatorToFc("KataloskiBroj", Validators.required, 'required', 'STRUCNOUSAVRSAVANJE.KATALOSKIBROJ.VALIDATION.REQUIRED');
    this.addValidatorToFc("Mesto", Validators.required, 'required', 'STRUCNOUSAVRSAVANJE.MESTO.VALIDATION.REQUIRED');
    this.addValidatorToFc("USvojstvuPredavaca", Validators.required, 'required', 'STRUCNOUSAVRSAVANJE.USVOJSTVUPREDAVACA.VALIDATION.REQUIRED');
    this.addValidatorToFc("Obavezno", Validators.required, 'required', 'STRUCNOUSAVRSAVANJE.OBAVEZNO.VALIDATION.REQUIRED');

    
    if (this.ParentProperty){
      this.baseFormGroup.patchValue({OsobaId: this.ParentProperty.Value});
      this.baseFormGroup.get('OsobaId').disable();
    }

  }

}
